import React from "react";
import { paymentSteps } from "./paymentFeatureConstant";
import MarqueeCardScroller from "../../../Utility/MarqueeCardScroller";

const PaymentCardScroller: React.FC = () => {
  return <MarqueeCardScroller items={paymentSteps} />;
};

export default PaymentCardScroller;
